import { render, staticRenderFns } from "./cdb-rdb.vue?vue&type=template&id=3490b34e&scoped=true&"
import script from "./cdb-rdb.vue?vue&type=script&lang=js&"
export * from "./cdb-rdb.vue?vue&type=script&lang=js&"
import style0 from "./cdb-rdb.vue?vue&type=style&index=0&id=3490b34e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3490b34e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VAutocomplete,VCol,VRow,VSelect,VTextField})
